import { Component, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { HttpLoaderService } from '@tymes4-shared';
import { TranslateService } from '@ngx-translate/core';
import { EventPlacement, EventPlacementService, VenueBuildingBlock, VenueBuildingBlockService } from '../../../api';

@Component({
    selector: 'app-section-selector',
    templateUrl: './section-selector.component.html',
    styleUrls: ['./section-selector.component.scss'],
    standalone: false
})
export class SectionSelectorComponent implements OnInit {

  constructor(  private venueBuildingBlockService: VenueBuildingBlockService,
                private eventPlacementService: EventPlacementService,
                private loader : HttpLoaderService,
                private translate: TranslateService) { }

  @Output() onSelected = new EventEmitter<object>();

  pageSize: number = 7;

  //NEW IMPLEMENTATIONS
  allSections = null;
  eventId: number = null;
  event: any = null;
  parentId: number = null;
  parentObject: any = null;
  tvwNodes = null;

  lastUsedNegative = null;

  ngOnInit() {

  }

  initialize(parentId, eventId: number) {

    this.parentId = parentId;
    this.eventId = eventId;

    let observable = null;

    if (this.eventId !== null) {
      observable = this.eventPlacementService.getEventPlacement(this.parentId);
    }
    else {
      observable = this.venueBuildingBlockService.getVenueBuildingBlock(this.parentId);
    }

    observable.subscribe((data: VenueBuildingBlock | EventPlacement) => {
      this.parentObject = data;
      this.loadSections();
    });
  }

  private loadSections () {

    this.loader.open();

    let observable = null;

    if (this.eventId !== null) {
      observable = this.eventPlacementService.getEPChildSectionsRecursive(this.parentId);
    }
    else {
      observable = this.venueBuildingBlockService.getVBBChildSectionsRecursive(this.parentId);
    }

    observable.subscribe((sections: VenueBuildingBlock[] | EventPlacement[]) => {
      this.allSections = sections;
      this.lastUsedNegative = -1;
      this.tvwNodes = this.convertToNodes(this.parentId, this.parentObject.Name);
      this.loader.close();
    });
  }

  convertToNodes(parentId, parentName) {
    let resultNodes = [];

    const filtered = this.allSections.filter(function (section) {
      if (section.ParentId === parentId) return section;
    });

    for (let section of filtered) {
      const children = this.convertToNodes(section.Id, section.Name);
      resultNodes.push({
        id: section.Id,
        parentId: parentId,
        name: section.Name,
        hasUnpublishedChanges: section.HasUnpublishedChanges,
        children: children
      });
    }

    if (!this.eventId || this.eventId === null) {
      //add the new section
      resultNodes.push({
        id: this.lastUsedNegative,
        parentId: parentId,
        name: this.translate.instant('COMPONENTS.VENUE-DEFENITION.SECTION-SELECTOR.ADD-NEW-SECTION.NAME', {parentName}),
        children: null
      });
    }

    return resultNodes;
  }

  onNodeSelect(e) {
    if (e.node.id < 0) {
      //new item node clicked
      this.onSelected.emit( {
        Id: -1,
        ParentId: e.node.data.parentId,
        TypeId: 2 //add a section
      });
    }
    else {
      //find the clicked section
      const filtered = this.allSections.filter(function (section) {
        if (section.Id === e.node.id) return section;
      });

      this.selectSection(filtered[0]);
    }
  }

  selectSection(section) {
    this.editingVBB = section;

    //let the master know a selection has been made
    this.onSelected.emit( {
      Id: section.Id,
      ParentId: section.ParentId,
      TypeId: section.VenueBuildingBlockTypeId
    });

  }

  sectionUpdated (id) {
    this.loadSections();
  }

  venuedefinition;
  editingVBB = null;
}
